import './Navbar.css'
import Logo from '../../image/Logo.png'
import Navbar from 'react-bootstrap/Navbar'
import jQuery from 'jquery';
import { Nav } from 'react-bootstrap';





(function($) { 

  $(function() {
    var header = $(".start-style");
    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
    
      if (scroll >= 10) {
        header.removeClass('start-style').addClass("scroll-on");
      } else {
        header.removeClass("scroll-on").addClass('start-style');
      }
    });
  });   
    

    
  
 
  
  
  
  })(jQuery); 


  (function($) { 
    $('.navbar-nav>li>a').on('click', function(){
        $('.navbar-collapse').collapse('hide');
    });
})(jQuery); 


function Navbarr(){
    
    return(
        <Navbar collapseOnSelect expand="lg"  >
        <div className="navigation bg-light start-header start-style ">
                    <nav className="navbar navbar-expand-lg navbar-light bg-light navigation navbar-fixed-top ">
                    <Nav.Link className="navbar-brand" href="/" ><img src={Logo} alt="" srcset="" /></Nav.Link>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav mr-auto">
                        <li className="nav-item ">
                        <Nav.Link className="nav-link" href="/About-us"  >About us</Nav.Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Nav.Link className="nav-link dropdown-toggle"  href="/maintenance" >
                            Maintenance                          
                            </Nav.Link>
                           
                        </li>
                        <li className="nav-item dropdown">
                            <Nav.Link className="nav-link dropdown-toggle" href="/energie-renouvable" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Renewable Energy
                            </Nav.Link>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                            <a className="dropdown-item" href="/energie-renouvable#Photovoltaïque">Photovoltaic </a>
                                <a className="dropdown-item" href="/energie-renouvable#efficacité-énergétique">Energy efficiency</a> 
                                <a className="dropdown-item" href="/energie-renouvable#Thermal-solar-energy">Thermal solar energy </a>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <Nav.Link className="nav-link dropdown-toggle" href="/management" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Management
                            </Nav.Link>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                            <a className="dropdown-item" href="/management#accompagnement-iso-9001">Assistance  ISO 9001</a>
                                <a className="dropdown-item" href="/management#accompagnement-iso-17025">Assistance  ISO 17025</a>
                                <a className="dropdown-item" href="/management#accompagnement-iso-45001">Assistance  ISO 45001</a>
                                <a className="dropdown-item" href="/management#accompagnement-iso-50001">Assistance  ISO 50001</a>
                                <a className="dropdown-item" href="/management#accompagnement-IATF-16949">Assistance  IATF 16949</a>
                            </div>
                        </li>
                        <li className="nav-item">
                            <Nav.Link className="nav-link" href='/Environment'>Environment</Nav.Link>
                        </li>
                        
                        <li className="nav-item">
                            <Nav.Link className="nav-link" href='/contact'>Contact</Nav.Link>
                        </li>
                        
                        </ul>
                    </div>
                    </nav>
                    </div>
                    </Navbar>
 );

}
export default Navbarr ;